import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { currentRouteSet } from '../../actions/actions';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'
import { pathSpliter, dateTimeFormat, currentDateTime, getDateTimeFromISODT } from '../../lib/functions'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DateFnsUtils from '@date-io/date-fns'; // choose your libs
import { API_URL } from '../../config';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import _ from 'lodash';
import PrintIcon from '@material-ui/icons/Print';
import Select from 'react-select';
import '../commons/commons.css'


import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import swal from 'sweetalert';
import InstitutionProfile from '../commons/institution_profile'
import ReactToPrint from "react-to-print";
import commaNumber from 'comma-number';
let format = commaNumber.bindWith(',', '.')
const CustomerTransactionHistory = ({ location, currentRoute, currentRouteSet, authInfo }) => {
  const classes = useStyles();
  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
  }, []);
  let [customers, customersSet] = useState([]);
  let [areas, areasSet] = useState([]);
  let [dueAreas, dueAreasSet] = useState([]);
  let [selectedCustomer, selectedCustomerSet] = useState(null);
  let [selectedArea, selectedAreaSet] = useState(null);
  let [report, reportSet] = useState([]);
  let [print, printSet] = useState(false);
  let [reportLoading, reportLoadingSet] = useState(false);
  let [typeMenuOpen, typeMenuOpenSet] = useState(false);


  let [byDateTime, byDateTimeSet] = useState({
    fromDate: currentDateTime,
    toDate: currentDateTime
  })

  let typeRef = useRef(null);
  let customerRef = useRef(null);
  let areaRef = useRef(null);
  let fromDateRef = useRef(null);
  let reportRef = useRef(null);
  let searchBtnRef = useRef(null);


  let [types, typesSet] = useState([{ label: 'All Customer Due', value: null }, { label: 'Area Wise', value: 'area' },
  { label: 'Customer Wise', value: 'customer' },
  { label: 'Retail Type Wise', value: 'retail' }, { label: 'Wholesale Type Wise', value: 'wholesale' }]);
  let [selectedType, selectedTypeSet] = useState({ label: 'All Customer Due', value: null });

  useEffect(() => {
    getCusomers();
    getAreas();
  }, []);

  let getCusomers = async () => {
    try {
      await axios.post(`${API_URL}/api/get-customers`, { 'select-type': 'active' }, { headers: { 'auth-token': authInfo.token } }).then(res => {
        customersSet(res.data.message || [])
      })
    } catch (_error) {
      customersSet([])
    }
  }

  let getAreas = async () => {
    try {
      await axios.post(`${API_URL}/api/get-areas`, { 'select-type': 'active' }, { headers: { 'auth-token': authInfo.token } }).then(res => {
        const areaList = res.data.message || [];
        areasSet(areaList)
        dueAreasSet(areaList)
      })
    } catch (_error) {
      areasSet([])
      dueAreasSet([])
    }
  }

  const readRows = (data) => Array.isArray(data)
    ? data
    : Array.isArray(data?.message)
      ? data.message
      : Array.isArray(data?.data)
        ? data.data
        : [];

  const getCustomerLabel = (option) => {
    if (!option) return "";
    return String(
      option.display_text ||
      option.customer_name ||
      option.customer_institution_name ||
      option.customer_code ||
      ""
    );
  };

  const getAreaLabel = (option) => String(option?.area_name || "");

  const areaOptions = dueAreas.length > 0 ? dueAreas : [];

  const focusAfterTypeSelect = (type) => {
    setTimeout(() => {
      typeRef.current?.blur?.();
      if (type?.value === 'customer') {
        customerRef.current?.focus()
      } else if (type?.value === 'area') {
        areaRef.current?.focus()
      } else {
        searchBtnRef.current?.focus()
      }
    }, 60)
  }

  const focusSearchAfterDropdownSelect = (event) => {
    setTimeout(() => {
      event?.target?.blur?.();
      searchBtnRef.current?.focus()
    }, 90)
  }



  let getSearchResult = async () => {
    if (selectedType?.value == 'customer' && selectedCustomer == null) {
      swal({ title: 'Select a customer', icon: 'warning' });
      return;
    }

    if (selectedType?.value == 'area' && selectedArea == null) {
      swal({ title: 'Select an area', icon: 'warning' });
      return;
    }

    let payload = null;
    if (selectedType?.value == 'customer') {
      payload = { customerId: selectedCustomer.customer_id };
    } else if (selectedType?.value == 'area') {
      payload = { areaId: selectedArea.area_id };
    } else if (selectedType?.value == 'retail' || selectedType?.value == 'wholesale') {
      payload = { customerType: selectedType.value };
    }


    reportLoadingSet(true)
    try {
      const res = await axios.post(`${API_URL}/api/get-customer-due`, payload, { headers: { 'auth-token': authInfo.token } })
      const rows = readRows(res.data);
      reportSet(rows)
      printSet(true)
      if (rows.length === 0) {
        swal({ title: 'No due data found for this filter', icon: 'info' });
      }
    } catch (error) {
      reportSet([])
      printSet(false)
      swal({
        title: 'Failed to load customer due report',
        text: error?.response?.data?.message || error?.response?.data?.error || error?.message || 'Network Error',
        icon: 'error'
      });
    } finally {
      reportLoadingSet(false)
    }

  }


  let ReportDom = React.forwardRef((props, ref) => {
    return (<div ref={ref}>
      <InstitutionProfile />
      {
        report.length > 0 ? (
          <Paper className={classes.paper} style={{ marginTop: '8px', marginBottom: '5px' }} >

            <p className="print-source" style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', color: '#222' }}>Customer Due Report </p>

            <TableContainer >
              <Table className={classes.table} size="small" aria-label="a dense table" className="report-dom">
                <TableHead>
                  <TableRow>
                    <TableCell align="left" style={{ width: '1%' }}>SL</TableCell>
                    <TableCell align="left" style={{ width: '10%' }}>Customer Code</TableCell>
                    <TableCell align="left" style={{ width: '15%' }}>Customer Name</TableCell>
                    <TableCell align="left" style={{ width: '15%' }}>Institution</TableCell>
                    <TableCell align="left" style={{ width: '19%' }}>Address</TableCell>
                    <TableCell align="right" style={{ width: '15%' }}>Mobile No</TableCell>
                    <TableCell align="right" style={{ width: '15%' }}>Due Amount</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    report.map((row, sl) => (
                      <TableRow key="">
                        <TableCell>{sl + parseFloat(1)}.</TableCell>

                        <TableCell align="left">{row.customer_code}</TableCell>
                        <TableCell align="left">{row.customer_name}</TableCell>
                        <TableCell align="left">{row.customer_institution_name}</TableCell>
                        <TableCell align="left">{row.customer_address}</TableCell>
                        <TableCell align="right">{row.customer_mobile_no}</TableCell>
                        <TableCell align="right">{format(parseFloat(row.dueAmount).toFixed(2))}</TableCell>
                      </TableRow>
                    ))


                  }


                  <TableRow key="">
                    <TableCell colSpan={6} align="right">Total Due : </TableCell>
                    <TableCell align="right">{format(_.sumBy(report, curr => Number(curr.dueAmount)).toFixed(2))}</TableCell>
                  </TableRow>








                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        ) : ''
      }
    </div>)
  })

  return (
    <div className={classes.root}>
      <Paper className={classes.paper} style={{ marginTop: '-25px', marginBottom: '5px' }}>
        <h4 style={{
          textAlign: 'left', margin: 0, padding: 0, marginTop: '-10px',
          marginBottom: '2px'
        }}>Customer Due Report</h4>



        <Grid container spacing={3} >
          <Grid item xs={12} sm={2} >
            <Select
              ref={typeRef}
              classNamePrefix="react-select"
              value={selectedType}
              menuIsOpen={typeMenuOpen}
              onMenuOpen={() => typeMenuOpenSet(true)}
              onMenuClose={() => typeMenuOpenSet(false)}
              onChange={(type) => {
                if (type == null) {
                  return false;
                }
                typeMenuOpenSet(false);
                selectedTypeSet(type);
                selectedCustomerSet(null);
                selectedAreaSet(null);
                reportSet([]);
                printSet(false);
                focusAfterTypeSelect(type)
              }}
              options={types}
              onKeyDown={(event) => {
                if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                  typeMenuOpenSet(true);
                  return;
                }

                if (event.key === 'Escape') {
                  typeMenuOpenSet(false);
                  return;
                }

                if (event.key === 'Enter' && !typeMenuOpen) {
                  event.preventDefault();
                  focusAfterTypeSelect(selectedType);
                }
              }}

            />
          </Grid>
          {
            selectedType != null && selectedType.value == 'customer' ? (
              <Grid item xs={12} sm={3} >
                <Autocomplete
                  size="small"

                  autoHighlight
                  openOnFocus={true}
                  style={{ width: '100%', height: '20px' }}
                  options={customers}
                  value={selectedCustomer}
                  getOptionLabel={getCustomerLabel}
                  onChange={(event, selectedObj) => {

                    selectedCustomerSet(selectedObj)
                    if (selectedObj) focusSearchAfterDropdownSelect(event)

                  }}

                  onKeyDown={event => {
                    if (event.key === "Enter") {
                      focusSearchAfterDropdownSelect(event)
                    }
                  }}

                  renderInput={(params) => <TextField
                    inputRef={customerRef}
                    {...params}
                    label="Customer "
                    variant="outlined"
                  />}
                />
              </Grid>
            ) : ''
          }

          {selectedType != null && selectedType.value == 'area' ? (
            <Grid item xs={12} sm={2} >
              <Autocomplete
                size="small"

                autoHighlight
                openOnFocus={true}
                  style={{ width: '100%', height: '20px' }}
                  options={areaOptions}
                  value={selectedArea}
                getOptionLabel={getAreaLabel}
                noOptionsText={areas.length > 0 ? 'No area has due data' : 'Loading areas'}
                onChange={(event, selectedObj) => {
                  selectedAreaSet(selectedObj)
                  if (selectedObj) focusSearchAfterDropdownSelect(event)
                }}
                onKeyDown={event => {
                  if (event.key === "Enter") {
                    focusSearchAfterDropdownSelect(event)
                  }
                }}

                renderInput={(params) => <TextField
                  inputRef={areaRef}
                  {...params}
                  label="Area "
                  variant="outlined"
                />}
              />
            </Grid>
          ) : ''}





          <Grid item xs={12} sm={1} >
            <Button style={{ marginTop: '5px', marginLeft: 'auto', fontSize: '14px' }}
              variant="contained"
              color="primary"
              className={classes.button}
              startIcon={<SearchIcon />}
              onClick={getSearchResult}
              disabled={reportLoading ? true : false}
              buttonRef={searchBtnRef}
              ref={searchBtnRef}
            >
              Search
            </Button>
          </Grid>

        </Grid>
      </Paper>

      {
        print ? (
          <Grid container >
            <Grid item xs={12} sm={12} >
              <Paper style={{ borderRadius: '0px', marginTop: '-7px' }}>
                <ReactToPrint
                  trigger={() => <PrintIcon style={{ cursor: 'pointer', marginLeft: '30px', marginTop: '3px', marginBottom: '-8px' }} />}
                  content={() => reportRef.current}
                />
              </Paper>

            </Grid>
          </Grid>
        ) : ''
      }

      <ReportDom ref={reportRef} />
    </div>

  )
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  inputField: {
    width: '100%',
    marginTop: '5px'
  },
  plusLinkDiv: {
    position: 'relative'
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: '-21px',
    fontSize: '29px',
    height: '21px',
    textAlign: 'right',
    position: 'absolute',
    right: 0,
    color: '#3e8d54'
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));


const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer
  }
}
export default connect(mapStateToPops, { currentRouteSet })(CustomerTransactionHistory);
